import * as API from './api'
import * as Types from './Types'

export function tryCreateLaundry(token, communityId, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_LAUNDRY
    })

    API.createLaundry(token, communityId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_LAUNDRY_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.CREATE_LAUNDRY_FAILED,
          payload: status
        })
      })
  }
}

export function tryUpdateLaundry(token, communityId, laundryId, postData) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_LAUNDRY
    })

    API.updateLaundry(token, communityId, laundryId, postData)
      .then(response => {
        dispatch({
          type: Types.UPDATE_LAUNDRY_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.UPDATE_LAUNDRY_FAILED,
          payload: status
        })
      })
  }
}

export function tryDeleteLaundry(token, communityId, laundryId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_LAUNDRY
    })

    API.deleteLaundry(token, communityId, laundryId)
      .then(() => {
        dispatch({
          type: Types.DELETE_LAUNDRY_SUCCESS,
          payload: laundryId
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_LAUNDRY_FAILED
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Laundries.js